var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoGlyph(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.46,13.76v-2.99c0-1.66-1.35-3-3-3h-5h-0.5H5.47c-1.1,0-2,0.9-2,2v12.99c0,1.1,0.9,2,2,2h14.49h0l0,0h5.5 c1.65,0,3-1.34,3-3v-3c0-1.04-0.54-1.96-1.35-2.5C27.93,15.72,28.46,14.8,28.46,13.76z M19.46,23.76h-14c-0.55,0-1-0.45-1-1V9.77 c0-0.55,0.45-1,1-1h14V23.76z M25.47,16.76c1.1,0,2,0.9,2,2v3c0,1.1-0.9,2-2,2h-5v-7H25.47L25.47,16.76z M27.46,13.76 c0,1.1-0.9,2-2,2h-5v-7h5c1.1,0,2,0.9,2,2V13.76z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.46,18.26c0-1-0.42-1.62-0.94-2c0.52-0.38,0.94-1,0.94-2c0-1.98-1.64-2.5-2.5-2.5h-6.5v4v1v4h6.5 C14.83,20.76,16.46,20.24,16.46,18.26z M8.46,12.76h5.5c0.25,0,1.5,0.09,1.5,1.5s-1.25,1.5-1.5,1.5h-5.5V12.76z M8.46,16.76h5.5 c0.25,0,1.5,0.09,1.5,1.5s-1.25,1.5-1.5,1.5h-5.5V16.76z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGlyph);
export default __webpack_public_path__ + "static/media/logo-glyph.90969c87cc5ffa676f53d27a014cd7ec.svg";
export { ForwardRef as ReactComponent };